
import ComponentMain from './components/ComponentMain'
import {Container,Row, Col, Card, Nav} from 'react-bootstrap'
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {BrowserRouter} from 'react-router-dom'
import './components/ComponentApp.scss'

function App() {
  return (
    <div className="App">
      
      <BrowserRouter>
        <Container id="container-principal">
          <Card>
            <Card.Header id="card-header" >
              <Row>
                
                  <Col sm={6} xs={12}>
                    <Nav variant="tabs" defaultActiveKey={window.location.href.split('?').length>1?window.location.href.split('?')[1].split("=")[1]:'para_apertura'}>
                      <Nav.Item className='list-group'>
                        <Nav.Link   className="list-item"  eventKey="para_apertura" href="?state=para_apertura">
                          ABIERTAS </Nav.Link>
                     </Nav.Item>
                     <Nav.Item className='list-group'>
                        <Nav.Link className="list-item"  eventKey="en_evaluacion" href="?state=en_evaluacion">
                          EN EVALUACIÓN </Nav.Link>
                        </Nav.Item>
                      <Nav.Item className='list-group'>
                        <Nav.Link  className="list-item"  eventKey="adjudicada" href="?state=adjudicada">
                           ADJUDICADAS</Nav.Link>
                        </Nav.Item>
                    </Nav>
                  </Col>
              </Row>
            </Card.Header>

            <Card.Body id="card-body">
              <ComponentMain/>
            </Card.Body>
            
          </Card>
         </Container>
      </BrowserRouter>
    </div>
  );
}

export default App;
